<script setup>
import { useCmsContentStore } from "@/stores/cms";
import dayjs from "dayjs";
import { useRouter } from "vue-router";
import { useTemplateStore } from "@/stores/template";
import { ref, watch } from "vue";
import commonUtils from "@/utils/commonUtils";

defineProps({
  generalQuestions: {},
  regularQuestions: {},
  advanceQuestions: {},
});

const cmsContentStore = useCmsContentStore();
cmsContentStore.getContactContent();

const router = useRouter();
const templateStore = useTemplateStore();
let equipmentType = ref(templateStore.responsive.equipmentType);
watch(
  () => templateStore.responsive.equipmentType,
  (newValue) => {
    equipmentType.value = newValue;
  }
);
</script>
<template>
  <section id="faqs_main_arae" class="section_padding">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="section_heading_center">
            <h2>{{ $t("frequent-answer-and-question") }}</h2>
          </div>
        </div>
      </div>
      <div v-if="equipmentType !== 'iphone'" class="row">
        <div class="col-lg-3 col-md-3 col-sm-3 col-3">
          <div class="header_back">
            <a @click="router.back">
              <i class="bi bi-arrow-left-square back_icon" size="40"></i>
              <span style="font-size: 27px">{{ $t("back") }}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="faqs_area_top">
        <div class="row">
          <div class="col-lg-8">
            <div class="faqs_three_area_wrapper">
              <!-- Item One -->
              <div
                v-if="
                  commonUtils.sortByParams(
                    generalQuestions,
                    'sequenceNumber'
                  ) &&
                  commonUtils.sortByParams(generalQuestions, 'sequenceNumber')
                    .length > 0
                "
                class="faqs_item_wrapper"
              >
                <h3>{{ $t("general-question") }}</h3>
                <div class="faqs_main_item">
                  <div id="accordionExample" class="accordion">
                    <div
                      v-for="(
                        generalQuestion, generalIndex
                      ) in commonUtils.sortByParams(
                        generalQuestions,
                        'sequenceNumber'
                      )"
                      :key="generalIndex"
                      class="accordion-item"
                    >
                      <h2
                        :id="'heading' + generalQuestion.id"
                        class="accordion-header"
                      >
                        <button
                          :aria-controls="'collapse' + generalQuestion.id"
                          :data-bs-target="'#collapse' + generalQuestion.id"
                          aria-expanded="true"
                          class="accordion-button"
                          data-bs-toggle="collapse"
                          type="button"
                        >
                          {{ generalQuestion.question }}
                        </button>
                      </h2>
                      <div
                        :id="'collapse' + generalQuestion.id"
                        :aria-labelledby="'heading' + generalQuestion.id"
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          <p>
                            {{ generalQuestion.answer }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Item Two -->
              <div
                v-if="
                  commonUtils.sortByParams(
                    regularQuestions,
                    'sequenceNumber'
                  ) &&
                  commonUtils.sortByParams(regularQuestions, 'sequenceNumber')
                    .length > 0
                "
                class="faqs_item_wrapper"
              >
                <h3>{{ $t("regular-question") }}</h3>
                <div
                  v-for="(
                    regularQuestion, regularIndex
                  ) in commonUtils.sortByParams(
                    regularQuestions,
                    'sequenceNumber'
                  )"
                  :key="regularIndex"
                  class="faqs_main_item"
                >
                  <div
                    :id="'accordionExample' + regularQuestion.id"
                    class="accordion"
                  >
                    <div class="accordion-item">
                      <h2
                        :id="'headingf1' + regularQuestion.id"
                        class="accordion-header"
                      >
                        <button
                          :aria-controls="'collapsef1' + regularQuestion.id"
                          :data-bs-target="'#collapsef1' + regularQuestion.id"
                          aria-expanded="true"
                          class="accordion-button"
                          data-bs-toggle="collapse"
                          type="button"
                        >
                          {{ regularQuestion.question }}
                        </button>
                      </h2>
                      <div
                        :id="'collapsef1' + regularQuestion.id"
                        :aria-labelledby="'headingf1' + regularQuestion.id"
                        :data-bs-parent="
                          '#accordionExample' + regularQuestion.id
                        "
                        class="accordion-collapse collapse"
                      >
                        <div class="accordion-body">
                          <p>
                            {{ regularQuestion.answer }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Item Three -->
              <div
                v-if="
                  commonUtils.sortByParams(
                    advanceQuestions,
                    'sequenceNumber'
                  ) &&
                  commonUtils.sortByParams(advanceQuestions, 'sequenceNumber')
                    .length > 0
                "
                class="faqs_item_wrapper"
              >
                <h3>{{ $t("advance-question") }}</h3>
                <div
                  v-for="(
                    advanceQuestion, advanceIndex
                  ) in commonUtils.sortByParams(
                    advanceQuestions,
                    'sequenceNumber'
                  )"
                  :key="advanceIndex"
                  class="faqs_main_item"
                >
                  <div
                    :id="'accordionExampleThree' + advanceQuestion.id"
                    class="accordion"
                  >
                    <div class="accordion-item">
                      <h2
                        :id="'headingf2' + advanceQuestion.id"
                        class="accordion-header"
                      >
                        <button
                          :aria-controls="'collapsef2' + advanceQuestion.id"
                          :data-bs-target="'#collapsef2' + advanceQuestion.id"
                          aria-expanded="true"
                          class="accordion-button"
                          data-bs-toggle="collapse"
                          type="button"
                        >
                          {{ advanceQuestion.question }}
                        </button>
                      </h2>
                      <div
                        :id="'collapsef2' + advanceQuestion.id"
                        :aria-labelledby="'headingf2' + advanceQuestion.id"
                        :data-bs-parent="
                          '#accordionExampleThree' + advanceQuestion.id
                        "
                        class="accordion-collapse collapse"
                      >
                        <div class="accordion-body">
                          <p>
                            {{ advanceQuestion.answer }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="faqs_call_area">
              <img alt="img" src="@/assets/img/icon/call.png" />
              <h5>
                {{ $t("contact-us") }}
                {{ dayjs(new Date().getTime()).format("MM/DD") }}
              </h5>
              <h3 v-if="cmsContentStore.contactContent">
                <a href="tel:+00-123-456-789">{{
                  cmsContentStore.contactContent.phoneNumber
                }}</a>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
